import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { CART_QUANTITY_CHANGED } from '../../Rutab/RutabConstants';
import { calculatePrice } from '../../Actions/Rutab/DecalEditor.action';
import { debounce } from 'lodash-es';
import UnlockProductTemplateEditModal from './Templates/UnlockProductTemplateEditModal';
const usePriceSelector = () => {
    return useSelector((state) => ({
        canvasType: state.decalEditor.canvasType,
        canvasSize: state.decalEditor.canvasSize,
        decalSettings: state.decalEditorAPI.settings,
        quantity: state.decalEditorAPI.cartQuantity,
        productTemplate: state.decalEditorAPI.productTemplate,
        fontSizeChanged: state.decalEditor.canvasTextProperty,
        objectCountChanged: state.decalEditor.objectCount,
        productTemplateModified: state.decalEditorAPI.productTemplateModified,
        canvasPriceRerendered: state.decalEditor.canvasPriceRerendered,
    }), shallowEqual);
};
const Price = ({ fabricCanvas }) => {
    const { canvasType, canvasSize, decalSettings, quantity, fontSizeChanged, objectCountChanged, productTemplate, productTemplateModified, canvasPriceRerendered, } = usePriceSelector();
    const [price, setPrice] = useState('--');
    const [isCalculatingPrice, setIsCalculatingPrice] = useState(false);
    const dispatch = useDispatch();
    const debouncedCalculatePrice = useCallback(debounce((quantity) => {
        if (canvasType && canvasSize && decalSettings && fabricCanvas) {
            setIsCalculatingPrice(true);
            const textObjects = fabricCanvas
                .getObjects()
                .filter((o) => o.type === 'textbox');
            const textObjectsData = textObjects.map((obj) => {
                const textObj = obj;
                return {
                    fontSize: textObj.fontSize || 0,
                    text: textObj.text,
                };
            });
            const priceRequest = {
                canvasSize: canvasSize,
                articleNumber: canvasType.articleNumber,
                textObjects: textObjectsData,
                quantity: quantity,
            };
            if (productTemplate && !productTemplateModified) {
                priceRequest.productTemplateId = productTemplate.variantId;
            }
            calculatePrice(priceRequest)
                .then((result) => {
                setPrice(result.formatedPriceAfterDiscount);
                setIsCalculatingPrice(false);
            })
                .catch((error) => {
                console.error('Error calculating price:', error);
                setIsCalculatingPrice(false);
            });
        }
    }, 500), [
        canvasType,
        canvasSize,
        decalSettings,
        fabricCanvas,
        productTemplate,
        productTemplateModified,
    ]);
    useEffect(() => {
        debouncedCalculatePrice(quantity);
    }, [
        debouncedCalculatePrice,
        canvasSize,
        quantity,
        fontSizeChanged,
        objectCountChanged,
        productTemplate,
        productTemplateModified,
        canvasPriceRerendered,
    ]);
    const handleQuantityChange = (e) => {
        const value = parseInt(e.target.value);
        if (!isNaN(value) && value > 0) {
            dispatch({
                type: CART_QUANTITY_CHANGED,
                payload: { cartQuantity: value },
            });
        }
        else {
            dispatch({
                type: CART_QUANTITY_CHANGED,
                payload: { cartQuantity: 1 },
            });
        }
    };
    return (_jsxs(_Fragment, { children: [productTemplate && (_jsxs(_Fragment, { children: [_jsx("span", { children: productTemplate.templateName }), _jsx(UnlockProductTemplateEditModal, { fabricCanvas: fabricCanvas })] })), !productTemplate && _jsx("span", { children: canvasType === null || canvasType === void 0 ? void 0 : canvasType.decalEditorTypeName }), isCalculatingPrice ? (_jsx("div", { className: "cart-section cart-section--skeleton", children: _jsx("div", { className: "skeleton skeleton-text skeleton-text--price" }) })) : (price && _jsx("div", { className: "price", children: price })), _jsxs("div", { className: "quantity-input", children: [_jsx("label", { htmlFor: "quantity", children: "Antal:" }), _jsx("input", { type: "number", id: "quantity", min: "1", value: quantity, onChange: handleQuantityChange })] })] }));
};
export default memo(Price);
